import BaseComponent from "../../../../lib/components/BaseComponent";
import PropTypes from "prop-types";
import {Button as MuiButton, Zoom} from "@mui/material";
import Tooltip from '@mui/material/Tooltip';

class Button extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      size: (this.props.size ? this.props.size : ''),
    }
  }

  onClick(e) {
    if (this.props.onClick !== undefined && this._status === BaseComponent.STATUS_ENABLED) {
      this.props.onClick(e, this.props.uid);
    }
  }

  render() {

    let {
      tooltip, disabled, variant = 'contained', size = 'medium', endIcon, id, color, startIcon, children, className
    } = this.props;

    let button = (<MuiButton
      endIcon={endIcon}
      id={id}
      size={size}
      sx={this.props.sx}
      className={className}
      disabled={disabled}
      color={color}
      startIcon={startIcon}
      onClick={(e) => this.onClick(e)}
      variant={variant}>
      {children}
    </MuiButton>);

    return tooltip && !disabled ? (<Tooltip title={tooltip} arrow TransitionComponent={Zoom} placement='top'>
      {button}
    </Tooltip>) : (button);

  }
}

Button.propTypes = {
  endIcon: PropTypes.node,
  startIcon: PropTypes.node,
  variant: PropTypes.oneOf(['outlined', 'contained', 'text']),
  uid: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  color: PropTypes.oneOf(['primary', 'secondary', 'error', '']),
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  widthFull: PropTypes.bool,
  tooltip: PropTypes.string
}

export default Button;
